import React, {PureComponent} from 'react';
import LazyLoad from '../../common/lazy-load/LazyLoad';
import {connect} from 'react-redux';
import {ButtonPrimary} from '@homeaway/react-buttons';
import {pushEdapEvent} from '../../../utils/edap';
import EdapViewTracker from '../../common/edap-view-tracker/EdapViewTracker';
import PlaceholderImage from '../../common/carousel/Placeholder';
import {BrandImage} from './brand-images';

import './styles.less';

const SCROLLINTOVIEW = ['summer2019sweepstakes'];

export const mapStateToProps = ({
    modules: {
        branding: {url, logo, heading, subheading, buttonLabel},
    },
    config: {themeId},
}) => ({
    url,
    logo,
    heading,
    subheading,
    buttonLabel,
    themeId,
});

export class BrandingComponent extends PureComponent {
    constructor(props) {
        super(props);
        this.container = React.createRef();
    }

    componentDidMount() {
        if (
            this.container.current !== null &&
            SCROLLINTOVIEW.includes(this.props.themeId)
        ) {
            this.container.current.scrollIntoView(true);
        }
    }

    handleButtonClick() {
        pushEdapEvent('generic.event', {
            actionlocation: 'branding-component',
            eventcategory: 'branding-component',
            eventaction: 'button-clicked',
        });
    }

    render() {
        const {url, logo, heading, subheading, buttonLabel} = this.props;

        return (
            <section className="BrandingContent section" ref={this.container}>
                <div className="section--centered">
                    <div className="BrandingContent__body">
                        {logo && (
                            <div className="BrandingContent__box1">
                                <LazyLoad
                                    placeholder={
                                        <PlaceholderImage alt={heading} />
                                    }
                                >
                                    <BrandImage {...this.props} />
                                </LazyLoad>
                            </div>
                        )}
                        <div className="BrandingContent__box2">
                            <h2 className="BrandingContent__heading">
                                {heading}
                            </h2>
                            <p className="BrandingContent__subheading">
                                {subheading}
                            </p>
                            {buttonLabel && url && (
                                <ButtonPrimary
                                    className="BrandingContent__button"
                                    href={url}
                                    target="_blank"
                                    label={buttonLabel}
                                    onClick={this.handleButtonClick}
                                />
                            )}
                        </div>
                    </div>
                </div>
                <EdapViewTracker
                    eventData={{actionlocation: 'branding-component'}}
                />
            </section>
        );
    }
}

export const Branding = connect(mapStateToProps)(BrandingComponent);

Branding.displayName = 'Branding';

export default Branding;
